import InputArea from "@component/form/InputArea";
import useReviewSubmit from "@hooks/useReviewSubmit";
import React, { useContext, useRef, useState } from "react";

import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import { MdReviews } from "react-icons/md";
import { FaStar } from "react-icons/fa";
import UploaderMulti from "@component/image-uploader/UploaderMulti";
import Error from "@component/form/Error";
import { UserContext } from "@context/UserContext";
import LoginModal from "@component/modal/LoginModal";
import { notifyError } from "@utils/toast";
import { IoStarOutline, IoStarSharp } from "react-icons/io5";

export default function ReviewDrawer({ product }) {
  const [accordionOpen, setAccordionOpen] = useState(false);
  const openAccordion = () => {
    setAccordionOpen(!accordionOpen);
  };
  const {
    state: { userInfo },
  } = useContext(UserContext);

  const [modalOpen, setModalOpen] = useState(false);

  const {
    handleSubmit,
    submitHandler,
    register,
    errors,
    loading,
    setvalEdit,
    rating,
    imageUrl,
    setImageUrl,
  } = useReviewSubmit(product);

  return (
    <>
      {modalOpen && (
        <LoginModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
      )}

      <div className="accordion" id="accordionExample">
        <div className="accordion-item bg-white border border-gray-200 rounded-lg">
          <h2 className="accordion-header mb-0" id="headingOne">
            <button
              className="
                accordion-button
                relative
                flex
                items-center
                w-full
                py-4
                px-5
                text-base text-gray-800 text-left
                bg-white
                border-0
                rounded-lg
                focus:outline-none
                justify-between
            "
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
              onClick={openAccordion}
            >
              <span>Share your Review</span>
              <span>
                {accordionOpen ? <AiOutlineMinus /> : <AiOutlinePlus />}
              </span>
            </button>
          </h2>

          <div
            id="collapseOne"
            className={`accordion-collapse rounded-lg bg-white collapse ${
              accordionOpen ? "max-h-auto" : "max-h-0"
            } overflow-hidden`}
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
            style={{ transition: "all 5s ease-in !important" }}
          >
            <div className="accordion-body py-4 px-5">
              <form
                className="flex flex-col justify-center"
                onSubmit={handleSubmit(submitHandler)}
                autoComplete={"off"}
              >
                <div className="grid grid-cols-1 gap-5">
                  <div className="form-group">
                    <InputArea
                      register={register}
                      label="Description"
                      name="text"
                      type="text"
                      placeholder="Type your review here"
                      Icon={MdReviews}
                    />

                    <Error errorName={errors.text} />
                  </div>
                  <div className="grid grid-cols-1 gap-5">
                    <div className="form-group flex">
                      {[...Array(5)].map((star, i) => {
                        let ratingValue = i + 1;
                        return (
                          <label key={i}>
                            <div className="hidden">{star}</div>
                            <input
                              onChange={setvalEdit}
                              type="radio"
                              name="rating"
                              value={ratingValue}
                              className="hidden"
                            />
                            {ratingValue <= rating ? (
                              <IoStarSharp />
                            ) : (
                              <IoStarOutline />
                            )}
                          </label>
                        );
                      })}
                    </div>
                  </div>
                  <div className="grid grid-cols-1 gap-5">
                    <div className="form-group flex">
                      <UploaderMulti
                        imageUrl={imageUrl}
                        setImageUrl={setImageUrl}
                      />
                    </div>
                  </div>
                  <button
                    disabled={loading}
                    onClick={() => {
                      if (!userInfo?.email) {
                        notifyError("Please login to write review");
                        setModalOpen(!modalOpen);
                      }
                    }}
                    type="submit"
                    className="w-full text-center py-3 rounded bg-emerald-950 text-white hover:bg-emerald-1000 transition-all focus:outline-none my-1"
                  >
                    Submit your review!
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
